/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

import { BillingFrequency } from '../enum_properties.js';
import { FlowType } from '../enum_properties.js';
import { FrequencySchedule } from '../enum_properties.js';
import { FrequencyType } from '../enum_properties.js';
import { Origin } from '../enum_properties.js';
import { ReferralType } from '../enum_properties.js';
import { Screen } from '../enum_properties.js';
import { ShareType } from '../enum_properties.js';
export const v2_CONTEXT = { protocols: { event_version: 2 } };

export class v2_BankHome_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'flow_type', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_DepositSetup_FailedProperties {
    static ErrorType = {
        apiError: 'api_error',
    };

    static Destination = {
        rothIra: 'roth_ira',
        traditionalIra: 'traditional_ira',
        personalBrokerage: 'personal_brokerage',
        custodial: 'custodial',
    };

    static DestinationManagementType = {
        robo: 'robo',
        selfDirected: 'self_directed',
    };

    static Source = {
        externalBank: 'external_bank',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['error_type']);
        var fixedNumber = 0;

        if (
            !Object.values(v2_DepositSetup_FailedProperties.ErrorType).includes(
                this.payload.error_type
            )
        ) {
            console.error('Invalid error_type value');
        }
        if (this.payload.amount != null) {
            fixedNumber = canFixNumber(this.payload.amount);
            if (fixedNumber === false) {
                console.error('amount must be of type Number');
            } else {
                this.payload.amount = fixedNumber;
            }
        }
        if (
            this.payload.currency != null &&
            !(
                typeof this.payload.currency === 'string' ||
                this.payload.currency instanceof String
            )
        ) {
            console.error('currency must be of type String');
        }

        if (
            this.payload.destination != null &&
            !Object.values(
                v2_DepositSetup_FailedProperties.Destination
            ).includes(this.payload.destination)
        ) {
            console.error('Invalid destination value');
        }

        if (
            this.payload.destination_management_type != null &&
            !Object.values(
                v2_DepositSetup_FailedProperties.DestinationManagementType
            ).includes(this.payload.destination_management_type)
        ) {
            console.error('Invalid destination_management_type value');
        }
        if (
            this.payload.error_code != null &&
            !(
                typeof this.payload.error_code === 'string' ||
                this.payload.error_code instanceof String
            )
        ) {
            console.error('error_code must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.frequency_schedule != null &&
            !Object.values(FrequencySchedule).includes(
                this.payload.frequency_schedule
            )
        ) {
            console.error('Invalid frequency_schedule value');
        }

        if (
            this.payload.frequency_type != null &&
            !Object.values(FrequencyType).includes(this.payload.frequency_type)
        ) {
            console.error('Invalid frequency_type value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.source != null &&
            !Object.values(v2_DepositSetup_FailedProperties.Source).includes(
                this.payload.source
            )
        ) {
            console.error('Invalid source value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'error_type',
            'amount',
            'currency',
            'destination',
            'destination_management_type',
            'error_code',
            'flow_type',
            'frequency_schedule',
            'frequency_type',
            'origin',
            'source',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_DepositSetup_SubmittedProperties {
    static Destination = {
        personalBrokerage: 'personal_brokerage',
        rothIra: 'roth_ira',
        traditionalIra: 'traditional_ira',
        custodial: 'custodial',
        bank: 'bank',
        retirement: 'retirement',
    };

    static DestinationManagementType = {
        selfDirected: 'self_directed',
        robo: 'robo',
    };

    static Source = {
        externalBank: 'external_bank',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'destination_management_type',
            'frequency_type',
        ]);
        var fixedNumber = 0;

        fixedNumber = canFixNumber(this.payload.amount);
        if (fixedNumber === false) {
            console.error('amount must be of type Number');
        } else {
            this.payload.amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.currency === 'string' ||
                this.payload.currency instanceof String
            )
        ) {
            console.error('currency must be of type String');
        }

        if (
            !Object.values(
                v2_DepositSetup_SubmittedProperties.Destination
            ).includes(this.payload.destination)
        ) {
            console.error('Invalid destination value');
        }

        if (
            !Object.values(
                v2_DepositSetup_SubmittedProperties.DestinationManagementType
            ).includes(this.payload.destination_management_type)
        ) {
            console.error('Invalid destination_management_type value');
        }

        if (
            !Object.values(FrequencyType).includes(this.payload.frequency_type)
        ) {
            console.error('Invalid frequency_type value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.frequency_schedule != null &&
            !Object.values(FrequencySchedule).includes(
                this.payload.frequency_schedule
            )
        ) {
            console.error('Invalid frequency_schedule value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }

        if (
            this.payload.source != null &&
            !Object.values(v2_DepositSetup_SubmittedProperties.Source).includes(
                this.payload.source
            )
        ) {
            console.error('Invalid source value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'destination_management_type',
            'frequency_type',
            'flow_type',
            'frequency_schedule',
            'origin',
            'screen',
            'source',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_DepositSetup_SucceededProperties {
    static Destination = {
        personalBrokerage: 'personal_brokerage',
        rothIra: 'roth_ira',
        traditionalIra: 'traditional_ira',
        custodial: 'custodial',
        bank: 'bank',
        retirement: 'retirement',
    };

    static DestinationManagementType = {
        selfDirected: 'self_directed',
        robo: 'robo',
    };

    static Source = {
        externalBank: 'external_bank',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'destination_management_type',
            'frequency_type',
        ]);
        var fixedNumber = 0;

        fixedNumber = canFixNumber(this.payload.amount);
        if (fixedNumber === false) {
            console.error('amount must be of type Number');
        } else {
            this.payload.amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.currency === 'string' ||
                this.payload.currency instanceof String
            )
        ) {
            console.error('currency must be of type String');
        }

        if (
            !Object.values(
                v2_DepositSetup_SucceededProperties.Destination
            ).includes(this.payload.destination)
        ) {
            console.error('Invalid destination value');
        }

        if (
            !Object.values(
                v2_DepositSetup_SucceededProperties.DestinationManagementType
            ).includes(this.payload.destination_management_type)
        ) {
            console.error('Invalid destination_management_type value');
        }

        if (
            !Object.values(FrequencyType).includes(this.payload.frequency_type)
        ) {
            console.error('Invalid frequency_type value');
        }
        if (
            this.payload.email != null &&
            !(
                typeof this.payload.email === 'string' ||
                this.payload.email instanceof String
            )
        ) {
            console.error('email must be of type String');
        }
        if (
            this.payload.fbclid != null &&
            !(
                typeof this.payload.fbclid === 'string' ||
                this.payload.fbclid instanceof String
            )
        ) {
            console.error('fbclid must be of type String');
        }
        if (
            this.payload.first_name != null &&
            !(
                typeof this.payload.first_name === 'string' ||
                this.payload.first_name instanceof String
            )
        ) {
            console.error('first_name must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.frequency_schedule != null &&
            !Object.values(FrequencySchedule).includes(
                this.payload.frequency_schedule
            )
        ) {
            console.error('Invalid frequency_schedule value');
        }
        if (
            this.payload.gclid != null &&
            !(
                typeof this.payload.gclid === 'string' ||
                this.payload.gclid instanceof String
            )
        ) {
            console.error('gclid must be of type String');
        }
        if (
            this.payload.irclickid != null &&
            !(
                typeof this.payload.irclickid === 'string' ||
                this.payload.irclickid instanceof String
            )
        ) {
            console.error('irclickid must be of type String');
        }
        if (
            this.payload.last_name != null &&
            !(
                typeof this.payload.last_name === 'string' ||
                this.payload.last_name instanceof String
            )
        ) {
            console.error('last_name must be of type String');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }
        if (
            this.payload.phone_number != null &&
            !(
                typeof this.payload.phone_number === 'string' ||
                this.payload.phone_number instanceof String
            )
        ) {
            console.error('phone_number must be of type String');
        }

        if (
            this.payload.source != null &&
            !Object.values(v2_DepositSetup_SucceededProperties.Source).includes(
                this.payload.source
            )
        ) {
            console.error('Invalid source value');
        }
        if (
            this.payload.user_dob != null &&
            !(this.payload.user_dob instanceof Date)
        ) {
            console.error('user_dob must be of type Date');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'destination_management_type',
            'frequency_type',
            'email',
            'fbclid',
            'first_name',
            'flow_type',
            'frequency_schedule',
            'gclid',
            'irclickid',
            'last_name',
            'origin',
            'phone_number',
            'source',
            'user_dob',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_EmploymentInfo_SubmittedProperties {
    static EmploymentStatus = {
        employed: 'employed',
        partTimeEmployed: 'part_time_employed',
        student: 'student',
        retired: 'retired',
        freelancer: 'freelancer',
        unemployed: 'unemployed',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'employment_status',
            'origin',
        ]);
        var fixedNumber = 0;

        if (
            !Object.values(
                v2_EmploymentInfo_SubmittedProperties.EmploymentStatus
            ).includes(this.payload.employment_status)
        ) {
            console.error('Invalid employment_status value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'employment_status',
            'origin',
            'flow_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_Home_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_Home_ViewedProperties {
    static PageVersion = {
        simplifiedHome: 'simplified_home',
        northstarHome: 'northstar_home',
        combinedHome: 'combined_home',
    };

    static Funded = {
        yes: 'yes',
        no: 'no',
    };

    static Paywalled = {
        yes: 'yes',
        no: 'no',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['page_version']);
        var fixedNumber = 0;

        if (
            !Object.values(v2_Home_ViewedProperties.PageVersion).includes(
                this.payload.page_version
            )
        ) {
            console.error('Invalid page_version value');
        }

        if (
            this.payload.funded != null &&
            !Object.values(v2_Home_ViewedProperties.Funded).includes(
                this.payload.funded
            )
        ) {
            console.error('Invalid funded value');
        }

        if (
            this.payload.paywalled != null &&
            !Object.values(v2_Home_ViewedProperties.Paywalled).includes(
                this.payload.paywalled
            )
        ) {
            console.error('Invalid paywalled value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'page_version',
            'funded',
            'paywalled',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_InternalNotificationAction_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tile_id']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tile_id === 'string' ||
                this.payload.tile_id instanceof String
            )
        ) {
            console.error('tile_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'tile_id']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_InternalNotificationDismiss_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tile_id']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tile_id === 'string' ||
                this.payload.tile_id instanceof String
            )
        ) {
            console.error('tile_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'tile_id']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_InternalNotification_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tile_id']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tile_id === 'string' ||
                this.payload.tile_id instanceof String
            )
        ) {
            console.error('tile_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'tile_id']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_InvestHome_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_InvestingQuestions_SubmittedProperties {
    static RiskTolerance = {
        conservative: 'conservative',
        moderate: 'moderate',
        aggressive: 'aggressive',
    };

    static TimeHorizon = {
        lessThanOneYear: 'less_than_one_year',
        shortTerm: 'short_term',
        midTerm: 'mid_term',
        longTerm: 'long_term',
    };

    static HasChildrenUnderEighteen = {
        yes: 'yes',
        no: 'no',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'income_range',
            'net_worth_range',
            'origin',
            'risk_tolerance',
            'time_horizon',
        ]);
        var fixedNumber = 0;

        if (
            !(
                typeof this.payload.income_range === 'string' ||
                this.payload.income_range instanceof String
            )
        ) {
            console.error('income_range must be of type String');
        }
        if (
            !(
                typeof this.payload.net_worth_range === 'string' ||
                this.payload.net_worth_range instanceof String
            )
        ) {
            console.error('net_worth_range must be of type String');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            !Object.values(
                v2_InvestingQuestions_SubmittedProperties.RiskTolerance
            ).includes(this.payload.risk_tolerance)
        ) {
            console.error('Invalid risk_tolerance value');
        }

        if (
            !Object.values(
                v2_InvestingQuestions_SubmittedProperties.TimeHorizon
            ).includes(this.payload.time_horizon)
        ) {
            console.error('Invalid time_horizon value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.has_children_under_eighteen != null &&
            !Object.values(
                v2_InvestingQuestions_SubmittedProperties.HasChildrenUnderEighteen
            ).includes(this.payload.has_children_under_eighteen)
        ) {
            console.error('Invalid has_children_under_eighteen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'income_range',
            'net_worth_range',
            'origin',
            'risk_tolerance',
            'time_horizon',
            'flow_type',
            'has_children_under_eighteen',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_MoneyMovementResults_ViewedProperties {
    static Destination = {
        personalBrokerage: 'personal_brokerage',
        traditionalIra: 'traditional_ira',
        rothIra: 'roth_ira',
        custodial: 'custodial',
        retirement: 'retirement',
        bank: 'bank',
        externalBank: 'external_bank',
        debitCard: 'debit_card',
    };

    static Result = {
        succeeded: 'succeeded',
    };

    static Source = {
        personalBrokerage: 'personal_brokerage',
        traditionalIra: 'traditional_ira',
        rothIra: 'roth_ira',
        custodial: 'custodial',
        retirement: 'retirement',
        bank: 'bank',
        externalBank: 'external_bank',
        debitCard: 'debit_card',
    };

    static DestinationManagementType = {
        robo: 'robo',
        selfDirected: 'self_directed',
    };

    static SourceManagementType = {
        robo: 'robo',
        selfDirected: 'self_directed',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'flow_type',
            'frequency_type',
            'result',
            'source',
        ]);
        var fixedNumber = 0;

        fixedNumber = canFixNumber(this.payload.amount);
        if (fixedNumber === false) {
            console.error('amount must be of type Number');
        } else {
            this.payload.amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.currency === 'string' ||
                this.payload.currency instanceof String
            )
        ) {
            console.error('currency must be of type String');
        }

        if (
            !Object.values(
                v2_MoneyMovementResults_ViewedProperties.Destination
            ).includes(this.payload.destination)
        ) {
            console.error('Invalid destination value');
        }

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (
            !Object.values(FrequencyType).includes(this.payload.frequency_type)
        ) {
            console.error('Invalid frequency_type value');
        }

        if (
            !Object.values(
                v2_MoneyMovementResults_ViewedProperties.Result
            ).includes(this.payload.result)
        ) {
            console.error('Invalid result value');
        }

        if (
            !Object.values(
                v2_MoneyMovementResults_ViewedProperties.Source
            ).includes(this.payload.source)
        ) {
            console.error('Invalid source value');
        }

        if (
            this.payload.destination_management_type != null &&
            !Object.values(
                v2_MoneyMovementResults_ViewedProperties.DestinationManagementType
            ).includes(this.payload.destination_management_type)
        ) {
            console.error('Invalid destination_management_type value');
        }

        if (
            this.payload.frequency_schedule != null &&
            !Object.values(FrequencySchedule).includes(
                this.payload.frequency_schedule
            )
        ) {
            console.error('Invalid frequency_schedule value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.source_management_type != null &&
            !Object.values(
                v2_MoneyMovementResults_ViewedProperties.SourceManagementType
            ).includes(this.payload.source_management_type)
        ) {
            console.error('Invalid source_management_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'amount',
            'currency',
            'destination',
            'flow_type',
            'frequency_type',
            'result',
            'source',
            'destination_management_type',
            'frequency_schedule',
            'origin',
            'source_management_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_MoneyMovementSetup_ViewedProperties {
    static Destination = {
        rothIra: 'roth_ira',
        traditionalIra: 'traditional_ira',
        personalBrokerage: 'personal_brokerage',
        custodial: 'custodial',
        retirement: 'retirement',
        bank: 'bank',
        externalBank: 'external_bank',
    };

    static DestinationManagementType = {
        robo: 'robo',
        selfDirected: 'self_directed',
    };

    static Source = {
        externalBank: 'external_bank',
        debitCard: 'debit_card',
        mobileCheck: 'mobile_check',
        eCash: 'e_cash',
        payroll: 'payroll',
        rothIra: 'roth_ira',
        traditionalIra: 'traditional_ira',
        personalBrokerage: 'personal_brokerage',
        custodial: 'custodial',
        retirement: 'retirement',
        bank: 'bank',
    };

    static SourceManagementType = {
        robo: 'robo',
        selfDirected: 'self_directed',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'amount',
            'currency',
            'flow_type',
            'frequency_type',
        ]);
        var fixedNumber = 0;

        fixedNumber = canFixNumber(this.payload.amount);
        if (fixedNumber === false) {
            console.error('amount must be of type Number');
        } else {
            this.payload.amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.currency === 'string' ||
                this.payload.currency instanceof String
            )
        ) {
            console.error('currency must be of type String');
        }

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (
            !Object.values(FrequencyType).includes(this.payload.frequency_type)
        ) {
            console.error('Invalid frequency_type value');
        }

        if (
            this.payload.destination != null &&
            !Object.values(
                v2_MoneyMovementSetup_ViewedProperties.Destination
            ).includes(this.payload.destination)
        ) {
            console.error('Invalid destination value');
        }

        if (
            this.payload.destination_management_type != null &&
            !Object.values(
                v2_MoneyMovementSetup_ViewedProperties.DestinationManagementType
            ).includes(this.payload.destination_management_type)
        ) {
            console.error('Invalid destination_management_type value');
        }

        if (
            this.payload.frequency_schedule != null &&
            !Object.values(FrequencySchedule).includes(
                this.payload.frequency_schedule
            )
        ) {
            console.error('Invalid frequency_schedule value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.source != null &&
            !Object.values(
                v2_MoneyMovementSetup_ViewedProperties.Source
            ).includes(this.payload.source)
        ) {
            console.error('Invalid source value');
        }

        if (
            this.payload.source_management_type != null &&
            !Object.values(
                v2_MoneyMovementSetup_ViewedProperties.SourceManagementType
            ).includes(this.payload.source_management_type)
        ) {
            console.error('Invalid source_management_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'amount',
            'currency',
            'flow_type',
            'frequency_type',
            'destination',
            'destination_management_type',
            'frequency_schedule',
            'origin',
            'source',
            'source_management_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_MyGoals_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_MyStash_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_Plan_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_PreferredPaymentMethod_SubmittedProperties {
    static Source = {
        creditDebit: 'credit_debit',
        externalBank: 'external_bank',
        bank: 'bank',
        personalBrokerage: 'personal_brokerage',
    };

    static ExternalAccountType = {
        creditDebit: 'credit_debit',
        bank: 'bank',
    };

    static SourceManagementType = {
        selfDirected: 'self_directed',
        robo: 'robo',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'flow_type',
            'origin',
            'screen',
            'source',
        ]);
        var fixedNumber = 0;

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (!Object.values(Screen).includes(this.payload.screen)) {
            console.error('Invalid screen value');
        }

        if (
            !Object.values(
                v2_PreferredPaymentMethod_SubmittedProperties.Source
            ).includes(this.payload.source)
        ) {
            console.error('Invalid source value');
        }

        if (
            this.payload.external_account_type != null &&
            !Object.values(
                v2_PreferredPaymentMethod_SubmittedProperties.ExternalAccountType
            ).includes(this.payload.external_account_type)
        ) {
            console.error('Invalid external_account_type value');
        }

        if (
            this.payload.source_management_type != null &&
            !Object.values(
                v2_PreferredPaymentMethod_SubmittedProperties.SourceManagementType
            ).includes(this.payload.source_management_type)
        ) {
            console.error('Invalid source_management_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'flow_type',
            'origin',
            'screen',
            'source',
            'external_account_type',
            'source_management_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_ReferralLandingPage_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['referral_type']);
        var fixedNumber = 0;

        if (!Object.values(ReferralType).includes(this.payload.referral_type)) {
            console.error('Invalid referral_type value');
        }
        if (
            this.payload.button != null &&
            !(
                typeof this.payload.button === 'string' ||
                this.payload.button instanceof String
            )
        ) {
            console.error('button must be of type String');
        }
        if (
            this.payload.campaign_id != null &&
            !(
                typeof this.payload.campaign_id === 'string' ||
                this.payload.campaign_id instanceof String
            )
        ) {
            console.error('campaign_id must be of type String');
        }
        if (
            this.payload.campaign_name != null &&
            !(
                typeof this.payload.campaign_name === 'string' ||
                this.payload.campaign_name instanceof String
            )
        ) {
            console.error('campaign_name must be of type String');
        }
        if (
            this.payload.campaign_tag != null &&
            !(
                typeof this.payload.campaign_tag === 'string' ||
                this.payload.campaign_tag instanceof String
            )
        ) {
            console.error('campaign_tag must be of type String');
        }
        if (this.payload.recipient_amount != null) {
            fixedNumber = canFixNumber(this.payload.recipient_amount);
            if (fixedNumber === false) {
                console.error('recipient_amount must be of type Number');
            } else {
                this.payload.recipient_amount = fixedNumber;
            }
        }
        if (this.payload.sender_amount != null) {
            fixedNumber = canFixNumber(this.payload.sender_amount);
            if (fixedNumber === false) {
                console.error('sender_amount must be of type Number');
            } else {
                this.payload.sender_amount = fixedNumber;
            }
        }
        if (
            this.payload.sender_first_name != null &&
            !(
                typeof this.payload.sender_first_name === 'string' ||
                this.payload.sender_first_name instanceof String
            )
        ) {
            console.error('sender_first_name must be of type String');
        }
        if (
            this.payload.sender_id != null &&
            !(
                typeof this.payload.sender_id === 'string' ||
                this.payload.sender_id instanceof String
            )
        ) {
            console.error('sender_id must be of type String');
        }
        if (
            this.payload.share_code != null &&
            !(
                typeof this.payload.share_code === 'string' ||
                this.payload.share_code instanceof String
            )
        ) {
            console.error('share_code must be of type String');
        }
        if (
            this.payload.t1_campaign_id != null &&
            !(
                typeof this.payload.t1_campaign_id === 'string' ||
                this.payload.t1_campaign_id instanceof String
            )
        ) {
            console.error('t1_campaign_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'referral_type',
            'button',
            'campaign_id',
            'campaign_name',
            'campaign_tag',
            'recipient_amount',
            'sender_amount',
            'sender_first_name',
            'sender_id',
            'share_code',
            't1_campaign_id',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_ReferralLandingPage_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['referral_type']);
        var fixedNumber = 0;

        if (!Object.values(ReferralType).includes(this.payload.referral_type)) {
            console.error('Invalid referral_type value');
        }
        if (
            this.payload.campaign_id != null &&
            !(
                typeof this.payload.campaign_id === 'string' ||
                this.payload.campaign_id instanceof String
            )
        ) {
            console.error('campaign_id must be of type String');
        }
        if (
            this.payload.campaign_name != null &&
            !(
                typeof this.payload.campaign_name === 'string' ||
                this.payload.campaign_name instanceof String
            )
        ) {
            console.error('campaign_name must be of type String');
        }
        if (
            this.payload.campaign_tag != null &&
            !(
                typeof this.payload.campaign_tag === 'string' ||
                this.payload.campaign_tag instanceof String
            )
        ) {
            console.error('campaign_tag must be of type String');
        }
        if (this.payload.recipient_amount != null) {
            fixedNumber = canFixNumber(this.payload.recipient_amount);
            if (fixedNumber === false) {
                console.error('recipient_amount must be of type Number');
            } else {
                this.payload.recipient_amount = fixedNumber;
            }
        }
        if (this.payload.sender_amount != null) {
            fixedNumber = canFixNumber(this.payload.sender_amount);
            if (fixedNumber === false) {
                console.error('sender_amount must be of type Number');
            } else {
                this.payload.sender_amount = fixedNumber;
            }
        }
        if (
            this.payload.sender_first_name != null &&
            !(
                typeof this.payload.sender_first_name === 'string' ||
                this.payload.sender_first_name instanceof String
            )
        ) {
            console.error('sender_first_name must be of type String');
        }
        if (
            this.payload.sender_id != null &&
            !(
                typeof this.payload.sender_id === 'string' ||
                this.payload.sender_id instanceof String
            )
        ) {
            console.error('sender_id must be of type String');
        }
        if (
            this.payload.share_code != null &&
            !(
                typeof this.payload.share_code === 'string' ||
                this.payload.share_code instanceof String
            )
        ) {
            console.error('share_code must be of type String');
        }
        if (
            this.payload.t1_campaign_id != null &&
            !(
                typeof this.payload.t1_campaign_id === 'string' ||
                this.payload.t1_campaign_id instanceof String
            )
        ) {
            console.error('t1_campaign_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'referral_type',
            'campaign_id',
            'campaign_name',
            'campaign_tag',
            'recipient_amount',
            'sender_amount',
            'sender_first_name',
            'sender_id',
            'share_code',
            't1_campaign_id',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_ReferralShareCode_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'referral_type',
            'share_type',
        ]);
        var fixedNumber = 0;

        if (!Object.values(ReferralType).includes(this.payload.referral_type)) {
            console.error('Invalid referral_type value');
        }

        if (!Object.values(ShareType).includes(this.payload.share_type)) {
            console.error('Invalid share_type value');
        }
        if (
            this.payload.campaign_id != null &&
            !(
                typeof this.payload.campaign_id === 'string' ||
                this.payload.campaign_id instanceof String
            )
        ) {
            console.error('campaign_id must be of type String');
        }
        if (
            this.payload.campaign_name != null &&
            !(
                typeof this.payload.campaign_name === 'string' ||
                this.payload.campaign_name instanceof String
            )
        ) {
            console.error('campaign_name must be of type String');
        }
        if (
            this.payload.campaign_tag != null &&
            !(
                typeof this.payload.campaign_tag === 'string' ||
                this.payload.campaign_tag instanceof String
            )
        ) {
            console.error('campaign_tag must be of type String');
        }
        if (this.payload.recipient_amount != null) {
            fixedNumber = canFixNumber(this.payload.recipient_amount);
            if (fixedNumber === false) {
                console.error('recipient_amount must be of type Number');
            } else {
                this.payload.recipient_amount = fixedNumber;
            }
        }
        if (this.payload.sender_amount != null) {
            fixedNumber = canFixNumber(this.payload.sender_amount);
            if (fixedNumber === false) {
                console.error('sender_amount must be of type Number');
            } else {
                this.payload.sender_amount = fixedNumber;
            }
        }
        if (
            this.payload.share_code != null &&
            !(
                typeof this.payload.share_code === 'string' ||
                this.payload.share_code instanceof String
            )
        ) {
            console.error('share_code must be of type String');
        }
        if (
            this.payload.t1_campaign_id != null &&
            !(
                typeof this.payload.t1_campaign_id === 'string' ||
                this.payload.t1_campaign_id instanceof String
            )
        ) {
            console.error('t1_campaign_id must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'referral_type',
            'share_type',
            'campaign_id',
            'campaign_name',
            'campaign_tag',
            'recipient_amount',
            'sender_amount',
            'share_code',
            't1_campaign_id',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SearchEntry_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, []);
        var fixedNumber = 0;

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SearchResult_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['screen', 'security_ticker']);
        var fixedNumber = 0;

        if (!Object.values(Screen).includes(this.payload.screen)) {
            console.error('Invalid screen value');
        }
        if (
            !(
                typeof this.payload.security_ticker === 'string' ||
                this.payload.security_ticker instanceof String
            )
        ) {
            console.error('security_ticker must be of type String');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'screen',
            'security_ticker',
            'origin',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionBillingFrequency_SubmittedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'billing_frequency',
            'origin',
            'plan_price_amount',
            'plan_price_currency',
        ]);
        var fixedNumber = 0;

        if (
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        fixedNumber = canFixNumber(this.payload.plan_price_amount);
        if (fixedNumber === false) {
            console.error('plan_price_amount must be of type Number');
        } else {
            this.payload.plan_price_amount = fixedNumber;
        }
        if (
            !(
                typeof this.payload.plan_price_currency === 'string' ||
                this.payload.plan_price_currency instanceof String
            )
        ) {
            console.error('plan_price_currency must be of type String');
        }
        if (this.payload.discount != null) {
            fixedNumber = canFixNumber(this.payload.discount);
            if (fixedNumber === false) {
                console.error('discount must be of type Number');
            } else {
                this.payload.discount = fixedNumber;
            }
        }
        if (
            this.payload.tier_plan != null &&
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            this.payload.tier_plan_unique_name != null &&
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'billing_frequency',
            'origin',
            'plan_price_amount',
            'plan_price_currency',
            'discount',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionDetails_ViewedProperties {
    static Variation = {
        activeSubscription: 'active_subscription',
        inactiveSubscription: 'inactive_subscription',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['variation']);
        var fixedNumber = 0;

        if (
            !Object.values(
                v2_SubscriptionDetails_ViewedProperties.Variation
            ).includes(this.payload.variation)
        ) {
            console.error('Invalid variation value');
        }

        if (
            this.payload.origin != null &&
            !Object.values(Origin).includes(this.payload.origin)
        ) {
            console.error('Invalid origin value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['variation', 'origin']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlanConfirm_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tier_plan']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'flow_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlanDetails_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'billing_frequency',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlanDetails_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
        ]);
        var fixedNumber = 0;

        if (!Object.values(FlowType).includes(this.payload.flow_type)) {
            console.error('Invalid flow_type value');
        }

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }
        if (
            !(
                typeof this.payload.tier_plan_unique_name === 'string' ||
                this.payload.tier_plan_unique_name instanceof String
            )
        ) {
            console.error('tier_plan_unique_name must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'flow_type',
            'origin',
            'tier_plan',
            'tier_plan_unique_name',
            'billing_frequency',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlanNextSteps_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tier_plan']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'flow_type',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlan_ClickedProperties {
    static PageVersion = {
        oldTier: 'old_tier',
        pilotPlan: 'pilot_plan',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tier_plan']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.page_version != null &&
            !Object.values(
                v2_SubscriptionPlan_ClickedProperties.PageVersion
            ).includes(this.payload.page_version)
        ) {
            console.error('Invalid page_version value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'flow_type',
            'page_version',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlan_SubmittedProperties {
    static PageVersion = {
        oldTier: 'old_tier',
        pilotPlan: 'pilot_plan',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin', 'tier_plan']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
        if (
            !(
                typeof this.payload.tier_plan === 'string' ||
                this.payload.tier_plan instanceof String
            )
        ) {
            console.error('tier_plan must be of type String');
        }

        if (
            this.payload.billing_frequency != null &&
            !Object.values(BillingFrequency).includes(
                this.payload.billing_frequency
            )
        ) {
            console.error('Invalid billing_frequency value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.page_version != null &&
            !Object.values(
                v2_SubscriptionPlan_SubmittedProperties.PageVersion
            ).includes(this.payload.page_version)
        ) {
            console.error('Invalid page_version value');
        }
        if (this.payload.plan_price_amount != null) {
            fixedNumber = canFixNumber(this.payload.plan_price_amount);
            if (fixedNumber === false) {
                console.error('plan_price_amount must be of type Number');
            } else {
                this.payload.plan_price_amount = fixedNumber;
            }
        }
        if (
            this.payload.plan_price_currency != null &&
            !(
                typeof this.payload.plan_price_currency === 'string' ||
                this.payload.plan_price_currency instanceof String
            )
        ) {
            console.error('plan_price_currency must be of type String');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'tier_plan',
            'billing_frequency',
            'flow_type',
            'page_version',
            'plan_price_amount',
            'plan_price_currency',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_SubscriptionPlan_ViewedProperties {
    static PageVersion = {
        oldTier: 'old_tier',
        pilotPlan: 'pilot_plan',
    };

    static Variation = {
        stashworks: 'stashworks',
    };

    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.flow_type != null &&
            !Object.values(FlowType).includes(this.payload.flow_type)
        ) {
            console.error('Invalid flow_type value');
        }

        if (
            this.payload.page_version != null &&
            !Object.values(
                v2_SubscriptionPlan_ViewedProperties.PageVersion
            ).includes(this.payload.page_version)
        ) {
            console.error('Invalid page_version value');
        }

        if (
            this.payload.variation != null &&
            !Object.values(
                v2_SubscriptionPlan_ViewedProperties.Variation
            ).includes(this.payload.variation)
        ) {
            console.error('Invalid variation value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, [
            'origin',
            'flow_type',
            'page_version',
            'variation',
        ]);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_Transfer_ClickedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }

        if (
            this.payload.screen != null &&
            !Object.values(Screen).includes(this.payload.screen)
        ) {
            console.error('Invalid screen value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin', 'screen']);
    }

    context() {
        return v2_CONTEXT;
    }
}
export class v2_TrustedContact_ViewedProperties {
    constructor(payload) {
        this.payload = payload ?? {};
    }

    validate() {
        validateRequiredProperties(this.payload, ['origin']);
        var fixedNumber = 0;

        if (!Object.values(Origin).includes(this.payload.origin)) {
            console.error('Invalid origin value');
        }
    }

    toJSON() {
        this.validate();

        return clearProperties(this.payload, ['origin']);
    }

    context() {
        return v2_CONTEXT;
    }
}

function validateRequiredProperties(obj, requiredProperties) {
    if (!obj) {
        console.error('Payload is required');
    }
    requiredProperties.forEach((propertyName) => {
        if (obj[propertyName] === undefined || obj[propertyName] === null) {
            console.error(`${propertyName} is required`);
        }
    });
}

function clearProperties(obj, allowedProperties) {
    var newObj = {};
    allowedProperties.forEach((propertyName) => {
        if (obj[propertyName] !== undefined && obj[propertyName] !== null) {
            var property = obj[propertyName];
            if (property instanceof Date) {
                newObj[propertyName] = property.toISOString();
            } else {
                newObj[propertyName] = obj[propertyName];
            }
        }
    });
    return newObj;
}

function isISODateString(string) {
    const regex =
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
    return regex.test(string);
}

function canFixNumber(input) {
    if (input === undefined) return false;
    let str = typeof input === 'number' ? input.toString() : input;
    const sanitizedStr = str.replace(/[, $]/g, '');
    const number = parseFloat(sanitizedStr);

    if (isNaN(number)) {
        return false;
    }

    return number;
}
